module.exports = __webpack_public_path__ + "static/woman_set_3gradeschooler.de67a407.svg";